import request from '@service/request';
import config from '@config';
import { getAuthOptions } from '@service/utils.js';

export const fetchTorneoEstado = () => request.get(config.apiURL + '/torneo/estado');

export const activateComodin = (token, fase) => 
  request.post(config.apiURL + '/comodines', { faseActivacion: fase }, getAuthOptions(token));
